import React, { useContext, useEffect, useRef, useState } from 'react';
import './Ratio.scss';
import DataTableComponent from '../../../components/dataTables/dataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { ThemeContext } from '../../../context/theme-context';
import COLORS from '../../../constants/color';
import { RatioServiceApi } from "../../../services/stockAnalysis/api";
import { Configuration } from "../../../services/stockAnalysis/configuration"
import { useDispatch, useSelector } from "react-redux";
import NumberFormatter from '../../../formatters/NumberFormatter';
import ErrorContent from '../../../components/error-boundary';
import Spinner from '../../../components/spinner';
import { APIControl } from '../../../helpers/APIControl';
import lodash from 'lodash';

const Ratio = (props) => {

    const selectedSecurity = useSelector((state) => state.security?.selectedSecurity);
    const numberFormatter = new NumberFormatter();
    const api = new RatioServiceApi(new Configuration({ basePath: process.env.REACT_APP_STOCK_ANALYSIS_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_STOCK_ANALYSIS_API_BASE_PATH));
    const user = useSelector((state) => state.auth?.user);
    const token = useSelector((state) => state.auth?.token);
    const accountId = useSelector((state) => state.auth?.accountId);

    const toast = useRef(null);
    const [theme, setTheme] = useState('dark'); // ['dark', 'light'
    const [columsData, setColumsData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [isShowDetail, setIsShowDetail] = useState(false);
    const currentTheme = useContext(ThemeContext).theme;
    const [expandedRows, setExpandedRows] = useState(null);
    const [selectedSymbol, setSelectedSymbol] = useState("");
    const [entityId, setEntityId] = useState();
    const [panelError, setPanelError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setTheme(currentTheme);
    }, [props]);

    useEffect(() => {
        setEntityId("sec.101.368");
        setSelectedSymbol("TUPRS:IS");
    }, []);

    useEffect(() => {
        if (entityId === undefined)
            return;
        populateData();
    }, [entityId]);

    useEffect(() => {
        if (selectedSecurity.id) {
            setEntityId(selectedSecurity.id);
            setSelectedSymbol(selectedSecurity.code);
        }
    }, [selectedSecurity.id]);

    //#region DataTable


    const onRowExpand = (event) => {
    };

    const onRowCollapse = (event) => {
    };

    const allowExpansion = (rowData) => {
        return rowData.detail.length > 0;
    };

    const expandAll = () => {
        let _expandedRows = {};
        tableData.forEach((p) => (_expandedRows[`${p.id}`] = true));
        setExpandedRows(_expandedRows);
    };

    const collapseAll = () => {
        setExpandedRows(null);
    };

    const clickShowDetails = () => {
        setIsShowDetail(!isShowDetail);
        expandAll();
        if (!isShowDetail) {
            return;
        }
        else {
            collapseAll();
        }
    }

    const mainTableNameBodyTemplate = (rowData) => {
        return (
            <>
                <div className=''>
                    <div className='mainTable-title roboto-medium-16'>
                        {rowData.name}
                    </div>
                </div>
            </>
        );
    };

    const subTableBodyTemplate = (rowData, item) => {
        // return (
        //     <div className="p-d-flex p-ai-center p-jc-center  text-right">
        //         <span className="p-d-flex p-ai-center p-jc-center">
        //             {
        //                 rowData[item.field] < 0 ? <span className="" style={{ color: COLORS.colorLiveQueotesRedText }}>
        //                     {rowData[item.field]}
        //                 </span> : <span className="" style={{ color: COLORS.colorLiveQueotesGreenText }}>
        //                     {rowData[item.field]}
        //                 </span>

        //             }
        //         </span>
        //     </div>
        // );

        let value = rowData[item.field];


        if (item.field == 'title') {
            return (
                <div className='subTable-title'>
                    <label> {value} </label>
                </div>
            );
        }
        else {
            if (value == undefined) {
                return (
                    <div className='subTable-value-text'>
                        <label> - </label>
                    </div>
                );
            }
            else {
                value = parseFloat(value);
                return (
                    <>
                        {value && value < 0 &&
                            <div className='subTable-value-text negative'>
                                {value ? numberFormatter.decimalNumber(value, 2) : '-'}
                            </div>
                        }

                        {value && value >= 0 &&
                            <div className='subTable-value-text positive'>
                                {value ? numberFormatter.decimalNumber(value, 2) : '-'}
                            </div>
                        }
                    </>
                )
            }
        }


    };

    const rowExpansionTemplate = (rowData) => {
        // return (
        //     <div className="expand-datatable">

        //         <DataTable value={data.detail} >

        //             <Column
        //                 field="title"
        //                 header=""
        //                 bodyStyle={{ width: "34%", fontSize: '16px', fontFamily: 'Roboto-Medium' }}
        //                 headerStyle={{ display: "none" }}
        //             ></Column>
        //             <Column
        //                 field="period1"
        //                 header=""
        //                 bodyStyle={{ width: "15%", fontFamily: 'Roboto-Regular' }}
        //                 headerStyle={{ display: "none" }}
        //                 body={bodyTemplate}

        //             ></Column>

        //             <Column
        //                 field="period2"
        //                 header=""
        //                 bodyStyle={{ width: "15%", fontFamily: 'Roboto-Regular' }}
        //                 headerStyle={{ display: "none" }}
        //                 body={bodyTemplate}

        //             ></Column>

        //             <Column
        //                 field="period3"
        //                 header=""
        //                 bodyStyle={{ width: "15%", fontFamily: 'Roboto-Regular' }}
        //                 headerStyle={{ display: "none" }}
        //                 body={bodyTemplate}

        //             ></Column>

        //             <Column
        //                 field="period4"
        //                 header=""
        //                 bodyStyle={{ width: "15%", fontFamily: 'Roboto-Regular' }}
        //                 headerStyle={{ display: "none" }}
        //                 body={bodyTemplate}

        //             ></Column>

        //             <Column
        //                 field="period5"
        //                 header=""
        //                 bodyStyle={{ width: "15%", fontFamily: 'Roboto-Regular' }}
        //                 headerStyle={{ display: "none" }}
        //                 body={bodyTemplate}

        //             ></Column>

        //         </DataTable>
        //     </div>
        // );

        return (
            <div className='subTable'>
                <DataTable className='' value={rowData.detail} >
                    <Column
                        field="title"
                        key={rowData.detail.name}
                        header=""
                        body={subTableBodyTemplate}
                        style={{ width: '20%', textAlign: 'left' }} />
                    <Column
                        field="period1"
                        header=""
                        body={subTableBodyTemplate}
                        style={{ width: '15%', textAlign: 'right' }} />
                    <Column
                        field="period2"
                        header=""
                        body={subTableBodyTemplate}
                        style={{ width: '15%', textAlign: 'right' }} />
                    <Column
                        field="period3"
                        header=""
                        body={subTableBodyTemplate}
                        style={{ width: '15%', textAlign: 'right' }} />
                    <Column
                        field="period4"
                        header=""
                        body={subTableBodyTemplate}
                        style={{ width: '15%', textAlign: 'right' }} />
                    <Column
                        field="period5"
                        header=""
                        body={subTableBodyTemplate}
                        style={{ width: '15%', textAlign: 'right' }} />
                </DataTable>
            </div >
        );
    };

    const mainTableHeaderTemplate = (data, item) => {
        return (
            <div className="roboto-medium-16">
                {item.header}
            </div>
        );
    };

    const dynamicColumns = columsData.map((col, i) => {
        return <Column
            key={col.id}
            field={col.field}
            header={(data) => mainTableHeaderTemplate(data, col)}
            style={{ width: '16%', textAlign: 'right' }}
            headerStyle={{ textAlign: 'right' }} />
    });
    {/* <Column field="" header={bodyTemplate('quarter5')} style={{ width: '16%', textAlign: 'right' }} headerStyle={{ textAlign: 'right' }} /> */ }

    //#endregion DataTable

    //#region API CALLS

    //#region RATIODATA

    const populateData = () => {

        api.stockanalysisRatioFetchGet(token, "tr-TR", entityId).then((res) => {

            // console.log(res);
            
            if (res.data.error) {
                setIsLoading(true);
                setPanelError(true);
                toast.current.show({ severity: 'error', summary: 'Hata', detail: res.data.error.message, life: 3000 });
                return;
            }
            
            res.data.categories = lodash.orderBy(res.data.categories, ['order'], ['asc']); // 'asc' artan sıra, 'desc' azalan sıra.

            let _columns = res.data.categories[0].rows[0].Columns;

            let tableColumns = [];
            _columns.forEach((item, i) => {
                let _item = {
                    field: "period" + (i + 1),
                    header: item,
                }
                tableColumns.push(_item);
            });

            setColumsData(tableColumns);

            let categories = res.data.categories;

            let _data = [];
            categories.forEach((item, i) => {
                let _item = {
                    id: i,
                    code: item.name + i,
                    name: item.name,
                    detail: []
                }

                item.rows.forEach((row, j) => {
                    let _row = {
                        id: i + "-" + j,
                        title: row.name,
                    }

                    row.Values.forEach((value, k) => {
                        if (value == 'NaN') {
                            value = 0;
                        }
                        else {
                            
                            value = parseFloat(value);
                            _row["period" + (k + 1)] = value;
                        }
                    });
                    _item.detail.push(_row);
                });

                _data.push(_item);
            });
            setTableData(_data);

            let _expandedRows = {};
            _data.forEach((p) => (_expandedRows[`${p.id}`] = true));
            setExpandedRows(_expandedRows);

            setIsLoading(false);
        }).catch((err) => {
            // console.log(err);
            setIsLoading(false);
            setPanelError(true);
        });
    }
    //#endregion RATIODATA

    //#endregion API CALLS

    return (
        <div className='ratio-screen transition'>
            <Toast ref={toast} />
            {isLoading && <Spinner height="800px" />}
            {panelError && <ErrorContent message="Bir hata oluştu" onButtonClick={() => populateData()} />}
            {(!isLoading && !panelError) &&

                <div className="datatable-responsive">

                    <DataTable key='id' value={tableData} expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                        onRowExpand={onRowExpand} onRowCollapse={onRowCollapse} rowExpansionTemplate={rowExpansionTemplate}
                        dataKey="id" tableStyle={{ minWidth: '60rem' }}>
                        <Column className='expander-sub' style={{ width: '1em' }} expander={allowExpansion} />
                        {/* <Column key={1} field="name" bodyStyle={{ width: "30%", fontSize: "16px", fontFamily: 'Roboto-Bold', color: theme == 'dark' ? COLORS.white : '#418079' }} /> */}
                        {/* <Column field="caption.name" header="mln" body="" style={{ width: '0%', paddingLeft: '0' }} /> */}

                        <Column field="name" body={mainTableNameBodyTemplate} header="mln TL" style={{ width: '15%', paddingLeft: '0' }} />

                        {dynamicColumns}
                    </DataTable>
                </div>

            }
        </div>
    );
}

export default Ratio;
